
















































































import { RootState } from "@/store";
import moment from "moment";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

//Component
import { CReqExecutionResultEnumToI18n } from "@/model/communication/CReqExecutionResultEnum";
import { GetI18nStringFromUserEventType, GetIconFromUserEventType, UserEventTypeEnum } from "@/model/data/enums/UserEventTypeEnum";
import { UserEvent } from "@/model/data/userEvents/UserEvent";
import { formatMilliseconds } from "@/utility/Formatter";
import EventDataCard from "./EventDataCard.vue";

//Model

export default Vue.extend({
    components: { EventDataCard },
    props: {
        event: UserEvent,
        showDialog: Boolean,
    },
    data() {
        return {
            eventWithRequestData: [
                UserEventTypeEnum.addUpdatePackage,
                UserEventTypeEnum.deleteUpdatePackage,
                UserEventTypeEnum.scheduleUpdate,
                UserEventTypeEnum.createUser,
                UserEventTypeEnum.createProfile,
                UserEventTypeEnum.deleteUser,
                UserEventTypeEnum.deleteProfile,
                UserEventTypeEnum.createFolder,
                UserEventTypeEnum.deleteFolder,
                UserEventTypeEnum.renameFolder,
                UserEventTypeEnum.moveFolder,
                UserEventTypeEnum.moveInstallation,
                UserEventTypeEnum.createDashboard,
                UserEventTypeEnum.deleteDashboard,
                UserEventTypeEnum.shareDashboard,
                UserEventTypeEnum.assignToAllLicenseModule,
                UserEventTypeEnum.editLicenseModule,
                UserEventTypeEnum.createBranch,
                UserEventTypeEnum.deleteBranch,
                UserEventTypeEnum.editBranch,
                UserEventTypeEnum.editBranchInstallations,
                UserEventTypeEnum.logDownload,
                UserEventTypeEnum.forceLogDownload,
                UserEventTypeEnum.machineReset,
                UserEventTypeEnum.openRemoteLinkSession,
                UserEventTypeEnum.closeRemoteLinkSession,
                UserEventTypeEnum.smartLockActivation,
                UserEventTypeEnum.enableSmartLock,
                UserEventTypeEnum.insertSmartLockClosingCode,
                UserEventTypeEnum.generateSmartLockChallengeCode,
                UserEventTypeEnum.editOrganizationsLicenses,
            ],
            eventWithResponseData: [UserEventTypeEnum.addUpdatePackage, UserEventTypeEnum.openRemoteLinkSession, UserEventTypeEnum.deviceOnBoarding],
        };
    },
    computed: {
        ...mapGetters(["longDateFormat", "isUserSuperAdmin"]),
        ...mapState({
            isCloud: (state: RootState) => state.application.isCloud,
        }),
        showUserEventInfo: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog");
            },
        },

        infos() {
            let infos = [
                {
                    label: this.$t("user_events.userEventType"),
                    value: this.$t(GetI18nStringFromUserEventType(this.event.eventType)),
                    icon: GetIconFromUserEventType(this.event.eventType),
                },
                { label: this.$t("common.timestamp"), value: moment.utc(this.event.timestamp).local().format(this.longDateFormat(true, true, true, true)), icon: "clock" },
                {
                    label: this.$t("user_events.executorUsername"),
                    value: this.event.executorUsername ? this.event.executorUsername : this.$t("common.notAvailable"),
                    icon: "user-check",
                },
                { label: this.$t("user_events.involvedUser"), value: this.event.involvedUser ? this.event.involvedUser : this.$t("common.notAvailable"), icon: "user" },
            ];
            if (this.isCloud && this.isUserSuperAdmin)
                infos.push({ label: this.$t("user_events.executionTime"), value: formatMilliseconds(this.event.executionTime), icon: "stopwatch" });
            if (this.event.eventType == UserEventTypeEnum.addUpdatePackage && !this.event.responseData.ValidPackage)
                infos.push({ label: this.$t("user_events.response"), value: this.$t("user_events.packageNotValid"), icon: "reply" });
            else if (this.event.eventType == UserEventTypeEnum.login && this.event.response != 0)
                infos.push({ label: this.$t("user_events.response"), value: this.$t(`user_events.${this.event.responseData.authresult}`), icon: "reply" });
            else infos.push({ label: this.$t("user_events.response"), value: this.$t(CReqExecutionResultEnumToI18n(this.event.response)), icon: "reply" });
            return infos;
        },
    },
    methods: {
        prettyJson(value) {
            return JSON.stringify(JSON.parse(value), null, 2);
        },
    },
});
